/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from "react";
import PropTypes from "prop-types";

import { useTable, useSortBy } from "react-table";

import { Table as RbxTable } from "rbx";

import "./DataTable.scss";

const Table = ({ columns, data, onRowClick, initialSortBy, onChangeSort }) => {
  const tableState = {
    pageIndex: 0,
    sortBy: initialSortBy,
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state: { sortBy },
  } = useTable(
    {
      columns,
      data,
      initialState: { ...tableState },
    },
    useSortBy
  );

  const renderTableHeaderSort = (column) => {
    if (column.isSorted) {
      return column.isSortedDesc ? " ▼" : " ▲";
    }
    return "";
  };

  useEffect(() => {
    onChangeSort(sortBy);
  }, [onChangeSort, sortBy]);

  return (
    <div className="data-table-container">
      <div className="table-container">
        <RbxTable {...getTableProps()} bordered fullwidth hoverable narrow>
          <RbxTable.Head>
            {headerGroups.map((headerGroup) => (
              <RbxTable.Row {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <RbxTable.Heading
                    className={column.type === "number" ? "right" : "left"}
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    {column.render("Header")}
                    <span>{renderTableHeaderSort(column)}</span>
                  </RbxTable.Heading>
                ))}
              </RbxTable.Row>
            ))}
          </RbxTable.Head>
          <RbxTable.Body {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <RbxTable.Row
                  {...row.getRowProps()}
                  onClick={() => onRowClick(row.original)}
                >
                  {row.cells.map((cell) => (
                    <RbxTable.Cell
                      className={
                        cell.column?.type === "number" ? "right" : "left"
                      }
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </RbxTable.Cell>
                  ))}
                </RbxTable.Row>
              );
            })}
          </RbxTable.Body>
        </RbxTable>
      </div>
    </div>
  );
};

Table.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
  onRowClick: PropTypes.func,
  initialSortBy: PropTypes.array,
  onChangeSort: PropTypes.func,
};

Table.defaultProps = {
  columns: [],
  data: [],
  initialSortBy: [],
  onRowClick: () => null,
  onChangeSort: () => null,
};
export default Table;
